import React from 'react';
import '../../../App.css';
import {Link} from 'react-router-dom';

export default function Programming() {
    
    return(
        <>
            <Link to="/DigitalPortfolio/hobbies" className="nav-back">
                    <div className='nav-back-text'>{"<"}Back</div>
            </Link>
            <h1 className='header'>Programming</h1>

            <p className='body'>
            After figuring out that programming may be a good career path for me I sought out a way to try it out. 
            I reached out to my father when I was 5 asking where to start. 
            He handed me one of his college books on learning C++ and explained I should try it out. 
            After going through the lessons and creating a simple calculator, my attention was turned away and I didn’t get back to learning more for it. 
            The following school year, I was offered to take a “computer science” class where they taught us HTML and how to create a simple website that belonged in the late 90’s and early 00’s – using a lot of cut and paste.
            </p>

            <p className='body'>
            While the elementary school introduced me to code, I did not get a full taste of it until I started high school and was able to take an Intro to Programming class. 
            There, I learned C# and gained my love of creating applications. 
            I continued this throughout high school and learned JAVA, JavaScript, and some more C++.
            </p>

            <p className='body'>
            Outside high school I started working on my own applications and learned how to work in more languages, such as Python and HTML 5. 
            I worked with jsReact, learned how to work with XMLs, CSVs, YAML, and JSON. 
            Picked up a couple IDEs and tried out Visual Studios, VS Code, NetBeans, Eclipse, Android studio, and learned how to create inside Unity and Unreal Engine.
            </p>

            <p className='body'>
            I continue to learn and grow to this day, enjoying what I create and finding additional ways to accomplish what I want to do.
            </p>

            {/* <Link className="nav-projects" to="/DigitalPortfolio/projects">
                    <div className='nav-projects-text'>Checkout my projects for some examples!</div>
            </Link> */}
        </>
    )
}